import React, { useState, useEffect, FC } from 'react';
import { styled } from 'linaria/lib/react';
import { useDidMount } from '@mtsbank/ui-kit';
interface IProps {
  children: React.ReactElement;
}
export const StickySearch: FC<IProps> = ({
  children
}) => {
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);
  const [isSticky, setSticky] = useState(false);
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const handleScroll = () => {
    const payElement = document.getElementById('search');
    if (!payElement) return;
    const payElementTop = payElement.getBoundingClientRect().top + 64;
    if (payElementTop >= 80) {
      setSticky(false);
    } else {
      setSticky(true);
    }
  };
  useDidMount(() => {
    handleScroll();
  });
  useEffect(() => {
    if (screenWidth < 600) {
      window.addEventListener('scroll', handleScroll);
    } else {
      setSticky(false);
    }
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [screenWidth]);
  if (!isSticky) {
    return null;
  }
  return <WrapperStickySearch id="sticky-search">{children}</WrapperStickySearch>;
};
const WrapperStickySearch = /*#__PURE__*/styled("div")({
  name: "WrapperStickySearch",
  class: "wfklznn"
});

require("./StickySearch.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./StickySearch.tsx");